import { combineReducers } from 'redux'
import errorReducer from './errorReducer'
import loginReducer from './loginReducer'
import SidebarReducer from './sidebarToggler'
import PgmcategorydataReducer from './pgmcategoryReducer'
import SearchcriteriaReducer from './searchcriteriaReducer'
import TrainerSearchReducer from './trainerReducer'
import QuerySearchReducer from './queryReducer'
import  FaqSearchReducer from './faqReducer'
import AnnouncementSearchReducer from './announcmentReducer'
import TrainingSearchReducer from './trainingReducer'
import NotifySearchReducer from './notificationReducer'
import queryPageReducer from './querypageReducer'
import FaqPageReducer from './faqPageReducer'
import  AnnouncementPageReducer from './announcmentPageReducer'
import TrainingPageReducer from './trainingPageReducer'
import TrainerPageReducer from './trainerPageReducer'
import TrainingdataTypeReducer from './trainingdataTypeReducer'
import NotifypageReducer from './notificationpageReducer'
import SidebarSettingReducer from './settingsidebarToggler'
import SidebarRewardReducer from './rewardsidebarToggler'
import RewardredeemSearchReducer from './rewardredeemsearch'
import RewardredeemPageReducer from './rewardredeempage'
import BannerFIlterDataReducer from './bannerlistFilterReducer'
import BannerListPageReducer from './bannerlistPageReducer'
import SidebarManagementReducer from './managementToggler'
import ModuleReducer from './moduleReducer'
import addQueryCommentReducer from './addQueryCommentReducer'
import queryCategoryReducer from './queryCategoryReducer'
import { ReferralListReducer } from './referralListReducer'
import retailerSearchcriteriaReducer from './retailerSearchcriteriaReducer'
import UniqueIdGenerationReducer from './uniqueIdGenerationReducer'
import uniqueIdGenerationPageReducer from './uniqueIdGenerationPageReducer'
import targetAchievementReducer from './targetAchievementReducer'
import Module2wReducer from './module2wReducer'
import firstLoginReducer from './firstLoginReducer'

export default combineReducers({
  errors: errorReducer,
  login: loginReducer,
  sidebarToggler: SidebarReducer,
  settingsidebarToggler:SidebarSettingReducer,
  managementsidebarToggler:SidebarManagementReducer,
  rewardsidebarToggler:SidebarRewardReducer,
  pgmCategory: PgmcategorydataReducer,
  pgmSearch:SearchcriteriaReducer,
  retailerSearch:retailerSearchcriteriaReducer,
  trainerSearch:TrainerSearchReducer,
  querySearch:QuerySearchReducer,
  faqSearch: FaqSearchReducer,
  announceSearch:AnnouncementSearchReducer,
  trainingSearch:TrainingSearchReducer,
  notifySearch:NotifySearchReducer,
  querpage:queryPageReducer,
  faqpage:FaqPageReducer,
  announcePage:AnnouncementPageReducer,
  trainingPage:TrainingPageReducer,
  trainerpage:TrainerPageReducer,
  trainingdataType:TrainingdataTypeReducer,
  notifypage:NotifypageReducer,
  redeemsearch:RewardredeemSearchReducer,
  redeempage:RewardredeemPageReducer,
  bannerpage:BannerListPageReducer,
  bannerfilter:BannerFIlterDataReducer,
  moduleReducer:ModuleReducer,
  addQueryCommentReducer:addQueryCommentReducer,
  QueryCategoryReducer:queryCategoryReducer,
  ReferralListReducer:ReferralListReducer,
  UniqueIdGeneration:UniqueIdGenerationReducer,
  uniqueIdGenerationPage:uniqueIdGenerationPageReducer,
  targetAchievement:targetAchievementReducer,
  module2wReducer:Module2wReducer,
  firstLogin: firstLoginReducer,
})
